import React from 'react';

import type { BlogSection } from '../../types/blog';
import Checklist from './sectionRenderers/Checklist';
import Comparison from './sectionRenderers/Comparison';
import Cta from './sectionRenderers/Cta';
import Gallery from './sectionRenderers/Gallery';
import Image from './sectionRenderers/Image';
import Step from './sectionRenderers/Step';
import Text from './sectionRenderers/Text';
import Toc from './sectionRenderers/Toc';

interface SectionRendererProps {
  section: BlogSection;
}

const SectionRenderer: React.FC<SectionRendererProps> = ({ section }) => {
  const { type, heading, data } = section;

  const body = (() => {
    switch (type) {
      case 'text':       return <Text data={data as import('../../types/blog').TextData} />;
      case 'step':       return <Step data={data as import('../../types/blog').StepData} />;
      case 'checklist':  return <Checklist data={data as import('../../types/blog').ChecklistData} />;
      case 'comparison': return <Comparison data={data as import('../../types/blog').ComparisonData} />;
      case 'cta':        return <Cta data={data as import('../../types/blog').CtaData} />;
      case 'toc':        return <Toc data={data as import('../../types/blog').TocData} heading={heading ?? undefined} />;
      case 'image':      return <Image data={data as import('../../types/blog').ImageData} />;
      case 'gallery':    return <Gallery data={data as import('../../types/blog').GalleryData} />;
      default:           return null;
    }
  })();

  if (!body) return null;

  return (
    <section className="mb-10">
      {heading && type !== 'toc' && type !== 'cta' && (
        <h2 className="text-xl font-bold vscode-text-primary mb-4">{heading}</h2>
      )}
      {body}
    </section>
  );
};

export default SectionRenderer;
